export default "__VITE_ASSET__RU8THqns__"